import { authClient, baseClient, getServiceURL } from '@/utils'
import Toggles from '@domain/toggles/Toggles'
import { ApiCaller } from '@front/utils'

const getAccountDetails = async () => {
	let response = await authClient.get(`${getServiceURL('users')}/v1/account`)

	if (Toggles.isEnabled("showQualifiedUserDataFromDynamics")) {
		const crmId = response.data.crm.contact.id
		const data = await ApiCaller.call('v2', "GET", `user/${crmId}`, null, { credentials: "include" })
		response = { data }
	}
	return response
}

const refreshToken = () => {
	return authClient.post(`${getServiceURL('users')}/v1/auth/refresh`)
}

const doLogout = () => {
	return authClient.post(`${getServiceURL('users')}/v1/auth/logout`)
}

const checkEmailExists = (email) => {
	return baseClient
		.get(`${getServiceURL('users')}/v1/users/email-validate/${email}`)
		.then(() => ({
			data: true,
			status: 200
		}))
		.catch((error) => {
			if (error.response.status === 404) {
				return {
					data: false,
					status: 404
				}
			}
			return error
		})
}

export default {
	getAccountDetails,
	refreshToken,
	doLogout,
	checkEmailExists
}
